import { render, staticRenderFns } from "./branchTab.vue?vue&type=template&id=5be1e179&scoped=true&"
import script from "./branchTab.vue?vue&type=script&lang=js&"
export * from "./branchTab.vue?vue&type=script&lang=js&"
import style0 from "./branchTab.vue?vue&type=style&index=0&id=5be1e179&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be1e179",
  null
  
)

export default component.exports